import React from 'react';

const VendorComparison = ({ comparisonData, vendors, fmt }) => {
  return (
    <div className="section-card">
      <h3 className="section-title">Vendor Comparison</h3>
      <div className="table-scroll-wrapper">
        <table className="comparison-table">
          <thead>
            <tr>
              <th rowSpan="2">PRODUCT &amp; TIER</th>
              {vendors.map(v => (
                <th key={v.key} colSpan="3" className={`vendor-group-header ${v.key}-header text-center`}>
                  {v.label.toUpperCase()}
                </th>
              ))}
            </tr>
            <tr>
              {vendors.map(v => (
                <React.Fragment key={v.key}>
                  <th>PRODUCT</th>
                  <th>SHIPPING</th>
                  <th>TOTAL</th>
                </React.Fragment>
              ))}
            </tr>
          </thead>
          <tbody>
            {comparisonData.map((row, i) => (
              <tr key={i}>
                <td>
                  <div className="font-weight-bold">{row.itemName}</div>
                  <div className="text-muted" style={{ fontSize: 11 }}>
                    {row.tierLabel} ({row.tierQty} PCS)
                  </div>
                </td>
                {vendors.map(v => (
                  <React.Fragment key={v.key}>
                    <td>{fmt(row.vendorData[v.key].totalProduct)}</td>
                    <td>{fmt(row.vendorData[v.key].totalShipping)}</td>
                    <td className="font-weight-bold">{fmt(row.vendorData[v.key].totalCost)}</td>
                  </React.Fragment>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default VendorComparison;
